export default function FinalCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-14 text-center shadow-xl">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6">
            Давайте обсудим задачи вашей команды
          </h2>
          <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed mb-4">
            Не существует универсальных тренингов. Каждая программа создаётся под конкретный бизнес, отрасль и цели компании.
          </p>
          <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed mb-10">
            Оставьте заявку — и мы предложим решение именно для вашей ситуации. Первая консультация бесплатна и ни к чему не обязывает.
          </p>
          <button
            onClick={() => scrollTo('contact-form')}
            className="bg-white text-teal-700 px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить консультацию
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}